import { useState } from 'react'
import { useSelector } from 'react-redux'
import useStepFormHook from './useStepFormHook'
import { IStore } from '../interfaces/Store'
import { IPatrimonyType } from '../interfaces/Step3'
import { IStepProps } from '../interfaces/Step'
import { MAX_CARDS } from '../enums/common'

const Step3FormHook = (props: IStepProps) => {
  const { form, onSubmit } = useStepFormHook(props)
  const { no_patrimony, patrimony_types } = useSelector(
    (stateReducer: IStore) => stateReducer.folderReducer.folder
  )

  const patrimonyType = {
    patrimoine_type: '',
    patrimoine_montant: '',
    key: 0,
  }
  const getInitialPatrimonyTypes = () => {
    if (!patrimony_types || patrimony_types.length < 1) {
      return [patrimonyType]
    }
    return patrimony_types.map((item, index) => ({ ...item, key: index }))
  }
  const [patrimonyCards, setPatrimonyCards] = useState<IPatrimonyType[]>(
    getInitialPatrimonyTypes()
  )
  const [noPatrimonyChecked, setNoPatrimonyChecked] = useState(
    no_patrimony === '1' || false
  )
  const addPatrimonyCard = () => {
    if (patrimonyCards.length === MAX_CARDS) {
      return
    }
    setPatrimonyCards((prevState) => {
      return [
        ...patrimonyCards,
        { ...patrimonyType, key: prevState[prevState.length - 1].key + 1 },
      ]
    })
  }
  const removePatrimonyCard = (index: number) => {
    setPatrimonyCards((prevState) => [
      ...prevState.filter((item, i) => i !== index),
    ])
  }

  const updatePatrimonyTypes = (index: number, value: IPatrimonyType) => {
    setPatrimonyCards((prevState) => {
      const newPatrimonyCards = [...prevState]
      newPatrimonyCards[index] = value
      return newPatrimonyCards
    })
  }

  const onCheckboxChange = () => {
    setNoPatrimonyChecked(!noPatrimonyChecked)
    setPatrimonyCards([patrimonyType])
  }

  const submitForm = (values: Record<string, any>) => {
    onSubmit({
      ...values,
      patrimony_types: values.patrimony_types.filter(
        (item: IPatrimonyType) => item !== null
      ),
    })
  }

  return {
    form,
    addPatrimonyCard,
    removePatrimonyCard,
    updatePatrimonyTypes,
    onCheckboxChange,
    patrimonyCards,
    noPatrimonyChecked,
    no_patrimony,
    patrimony_types,
    submitForm,
  }
}

export default Step3FormHook
